<template>
  <div class="carga-archivos">
    <div>
      <Titulo titulo="Carga de archivos" />
    </div>
    <b-row class="justify-content-center align-items-center">
      <b-col cols="12" md="10">
        <div class="mt-3 text-right">
          <img
            v-if="loading"
            class="loading"
            src="@/assets/images/loader.gif"
            alt
          />
        </div>
        <br />
        <div class="mx-auto" v-if="!loading">
          <h4
            class="color-secundary mb-4"
            v-text="'Actualizacion clientes'"
          ></h4>
          <hr />
          <!-- boton para descargar archivo ejemplo -->
          <!-- tabla de la actualizacion de cliente -->
          <b-row class="justify-content-ritgh align-items-ritgh">
            <b-col cols="12" md="6" class="text-left">
              <form @submit.prevent="enviarActualizacionCliente()">
                <div class="form-group row">
                  <div class="col-lg-12 col-md-12">
                    <b-form-file
                      ref="archivo_actualizacion_cliente"
                      required
                      size="md"
                      placeholder="Selecione un archivo"
                      browse-text="Anexar"
                      drop-placeholder="Suelte los archivos aqui...."
                      :disabled="dataLengthClientes == 0 || loading"
                      class="mt-2"
                      :accept="'.xlsx'"
                      :multiple="false"
                    >
                      <!-- style="padding-right: 80px;" -->
                      <template slot="file-name" slot-scope="{ names }">
                        <b-badge v-if="names.length > 0" variant="dark" class="ml-1"
                          >{{ names[0] }} | {{ names.length }} Archivo(s)
                          seleccionado(s)</b-badge
                        >
                      </template>
                    </b-form-file>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <div class="mt-3 text-right">
                      <b-button
                        type="submit"
                        class="ml-1 button-carga"
                        :disabled="dataLengthClientes == 0 || loading"
                        >Enviar</b-button
                      >
                    </div>
                  </div>
                </div>
              </form>
            </b-col>
            <b-col cols="12" md="6" class="text-right">
              <p >
                A través del siguiente botón podrá descargar el formato requerido para la actualización de clientes.
              </p>
              <div>
                <b-button
                  type="button"
                  class="ml-1 button-carga"
                  :disabled="loading"
                  @click="descargarDocumentoEjemplo()"
                  >Documento guia</b-button
                >
              </div>
            </b-col>
          </b-row>
        </div>

        <div class="mx-auto" v-if="!loading">
          <!-- tabla de la actualizacion de cliente -->
          <hr />
          <h4
            class="color-secundary"
            v-text="'Lista de procesos'"
          ></h4>
          <table-component
            :data="dataProcesos"
            pagination
            @click-event="clickEventProcesos"
            @click-buscar="buscar"
            :perPage="perPage"
            :dataLength="dataLengthProcesos"
          >
            <table-column
              slot="label"
              :label="'Archivo'"
              v-bind:value="'archivo'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Estado'"
              v-bind:value="'estado'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Fecha registros'"
              v-bind:value="'fecha_cargue'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Registros totales'"
              v-bind:value="'total_registros'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Registros buenos'"
              v-bind:value="'registros_buenos'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Registros malos'"
              v-bind:value="'registros_malos'"
              :customClass="'text-center'"
            ></table-column>
            <table-column slot="label" :label="'Descargar log'" :icon="'fa'">
              <template
                slot="icon"
                :icon="'fa fa-download'"
                :class="'btn btn-sm btn-info'"
                :slug="'Descargar'"
                :tooltip="'Descargar Log'"
                :loading="false"
              ></template>
            </table-column>
          </table-component>
          <div class="col-lg-12 col-md-12">
            <div class="mt-3 text-left">
              <b-button
                type="button"
                class="ml-1 button-carga"
                :disabled="loading"
                @click="getProcesos(1)"
                >Buscar procesos</b-button
              >
            </div>
          </div>
        </div>

        <div class="mx-auto" v-if="!loading">
          <hr />
          <h4
            class="color-secundary"
            v-text="'Actualizaciones pendientes'"
          ></h4>
          <table-component
            :data="dataClientes"
            pagination
            @click-event="clickEventPendientes"
            :perPage="perPage"
            :dataLength="dataLengthClientes"
          >
            <table-column
              slot="label"
              :label="'Cedula'"
              v-bind:value="'cedula'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Pagare'"
              v-bind:value="'pagare'"
              :customClass="'text-center'"
            ></table-column>
            <table-column
              slot="label"
              :label="'Nombre'"
              v-bind:value="'nombre'"
              :customClass="'text-center'"
            ></table-column>
          </table-component>
          <div class="col-lg-12 col-md-12">
            <div class="mt-3 text-left">
              <b-button
                type="button"
                class="ml-1 button-carga"
                :disabled="loading"
                @click="getPendientesActualizacionClientes(1)"
                >Buscar pendientes</b-button
              >
            </div>
          </div>
        </div>
      </b-col>
      <!-- Panel Derecho -->
    </b-row>
    </br>
  </div>
</template>
<script>
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileSaver from "file-saver";

export default {
  name: "ActualizacionClientes",
  data: () => {
    return {
      pagination: false,
      multiple: true,
      perPage: 100,
      dataClientes: [],
      dataLengthClientes: 0,
      dataProcesos: [],
      dataLengthProcesos: 0,
      end_consulta_actualizacion: false,
      end_consulta_procesos: false,
      envio_actualizacion: false,
      buttonsActives: ["finalizado"],
    };
  },
  computed: {
    loading() {
      return this.end_consulta_actualizacion == true &&
        this.envio_actualizacion == false &&
        this.end_consulta_procesos == true
        ? false
        : true;
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    async clickEventPendientes(element, slug) {
      console.log(element, slug);
      if (slug == "paginacion") {
        this.getPendientesActualizacionClientes(element.page);
      }
    },
    async clickEventProcesos(element, slug) {
      if(slug == "Descargar"){
          let descarga_log = new Promise((res, rej) => {
            this.$store.getters.api
              .get("pagos/decargar_log_actualizacion_cliente", {
                params: element,
              })
              .then((response) => {
                let nombre = "log_actualizacion_cliente.csv";
                let ruta = element.log.split("/");
                nombre = ruta[ruta.length - 1];
                console.log(element.log.split("/"));
                FileSaver.saveAs(
                  new Blob([response.data], { type: "text/csv;charset=utf-8" }),
                  nombre
                );
                res();
              })
              .catch((error) => {
                rej(error);
              });
          });

        descarga_log
          .then(() => {
            let toast = this.$toasted.show(
              "Archivo de log descargado con éxito",
              {
                theme: "toasted-primary",
                position: "bottom-right",
                duration: 5000,
              }
            );
          })
          .catch((error) => {
            console.log(error);
            let toast = this.$toasted.show(
              "Error intentando descargar el archivo",
              {
                theme: "toasted-primary",
                position: "bottom-right",
                duration: 5000,
              }
            );
          })
          .then(() => {
            this.$store.commit("SET_LOADING", false);
          });
      }
    },
    async getPendientesActualizacionClientes(page, paginar = "false") {
      this.end_consulta_actualizacion = false;
      try {
        let request = await this.$store.state.api.get(
          "/informes/operaciones_actualizacion_cliente",
          {
            params: {
              paginar,
              row: this.perPage,
              page,
            },
          }
        );
        this.dataClientes = request.data.datos;
        this.dataLengthClientes = request.data.paginacion.total;
        this.end_consulta_actualizacion = true;
      } catch (err) {
        this.end_consulta_actualizacion = true;
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
    },
    restablecerActualizacionCliente() {
      this.$refs["archivo_actualizacion_cliente"].$refs.input.files.reset();
    },
    async enviarActualizacionCliente() {
      this.envio_actualizacion = true;
      let data_file = new FormData();
      let data_pagos = JSON.stringify(this.dataClientes);
      data_file.append("data_pagos", data_pagos);
      const archivo_actualizacion = this.$refs["archivo_actualizacion_cliente"]
        .$refs.input.files;
      for (let i = 0; i < archivo_actualizacion.length; i++) {
        data_file.append("datos", archivo_actualizacion[i]);
      }

      try {
        let response = await this.$store.state.api.post(
          "/pagos/validar_actualizacion_cliente",
          data_file
        );

        this.$toasted.show(
          "Se actualizaran los datos especificados en el log",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
        this.getPendientesActualizacionClientes(1);
        this.getProcesos(1);
        //
        this.envio_actualizacion = false;
      } catch (err) {
        this.envio_actualizacion = false;
        this.$toasted.show("Ocurrió un error al enviar la actualización", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 5000,
        });
        this.getPendientesActualizacionClientes(1);
        this.getProcesos(1);
      }
    },
    async getProcesos(page, paginar = "false") {
      this.end_consulta_procesos = false;
      try {
        let request = await this.$store.state.api.get(
          "/informes/obtener_actualizaciones_cliente",
          {
            params: {
              paginar,
              row: this.perPage,
              page,
            },
          }
        );

        this.dataProcesos = request.data.datos;
        this.dataLengthProcesos = request.data.paginacion.total;
        this.end_consulta_procesos = true;
      } catch (err) {
        this.end_consulta_procesos = true;
        this.$toasted.show(
          "Ocurrió un error intentando consultar los registros pendientes",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }
      this.end_consulta_procesos = true;
    },
    descargarDocumentoEjemplo() {
      let archivo = "modificar_informacion_clientes.xlsx";

      this.$store.getters.api
        .post("/informes/obtener_documento",
          {
            id: 133,
          },
          { responseType: "arraybuffer" })
        .then((response) => {
          FileSaver.saveAs(
            new Blob([response.data]),
            archivo
          );
          // FileSaver.saveAs(
          //   new Blob([response.data], { type: "text/csv;charset=utf-8" }),
          //   archivo + ".xlsx"
          // );
          let toast = this.$toasted.show("Archivo descargado con éxito", {
            theme: "toasted-primary",
            position: "bottom-right",
            duration: 5000,
          });
        })
        .catch((error) => {
          console.log(error);
          let toast = this.$toasted.show(
            "Error intentando descargar el archivo",
            {
              theme: "toasted-primary",
              position: "bottom-right",
              duration: 5000,
            }
          );
        });
    },
  },
  mounted() {
    console.log("ActualizacionClientes");
    this.getPendientesActualizacionClientes(1);
    this.getProcesos(1);
  },
};
</script>
<style>
.card-body {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.4s ease;
}

.card-body:hover {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.custom-list-group {
  display: flex;
  width: 600px;
}

.custom-list-item {
  flex: 1;
}
</style>
